import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { onChangeLanguage } from '../locale/index';

const languageOptions = [
  { key: 'Arabic', text: 'Arabic', value: 'ar' },
  { key: 'English', text: 'English', value: 'en' }
  ]

const currentLanguage = localStorage.getItem('language');

const LocaleSelector = () => (
  <Dropdown
    button
    placeholder='Select Language'
    fluid
    labeled
    selection
    className='icon'
    icon='world'
    value={currentLanguage}
    options={languageOptions}
    onChange={onChangeLanguage}
  />
)

export default LocaleSelector;